import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/railways-item-01-1024.jpg")